import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Clock, TrendingUp, Bell, CheckCircle, ArrowRight, Search, Tag, Zap, Users, BookOpen } from 'lucide-react';
var categories = [
    { id: 'all', label: 'Todos', icon: Search },
    { id: 'monitoramento', label: 'Monitoramento', icon: TrendingUp },
    { id: 'alertas', label: 'Alertas', icon: Bell },
    { id: 'rotina', label: 'Rotina do Gestor', icon: CheckCircle },
    { id: 'ferramentas', label: 'Ferramentas', icon: Zap },
    { id: 'carreira', label: 'Carreira', icon: Users },
    { id: 'operacao', label: 'Operação', icon: Tag },
    { id: 'problemas', label: 'Solução de Problemas', icon: BookOpen },
];
// Posts reais do workspace
var blogPosts = [
    {
        id: '1',
        slug: 'como-monitorar-varios-clientes-sem-perder-controle',
        title: 'Como monitorar vários clientes sem perder o controle',
        excerpt: 'Gestores de tráfego que atendem múltiplos clientes enfrentam um desafio comum: acompanhar dezenas de campanhas simultaneamente. Descubra estratégias e ferramentas para manter tudo sob controle.',
        category: 'monitoramento',
        readTime: 7,
        publishedAt: '2025-01-14',
        featured: true,
    },
    {
        id: '2',
        slug: 'alerta-campanha-parada-como-agir-rapido',
        title: 'Alerta de campanha parada: como agir rápido antes que o cliente perceba',
        excerpt: 'Uma campanha pausada pode custar caro — tanto em resultados quanto em confiança. Veja como configurar alertas eficientes e protocolos de ação imediata.',
        category: 'alertas',
        readTime: 5,
        publishedAt: '2025-01-12',
    },
    {
        id: '3',
        slug: 'checklist-diario-gestor-trafego',
        title: 'Checklist diário do gestor de tráfego: o que verificar todo dia',
        excerpt: 'Uma rotina estruturada separa gestores amadores de profissionais. Conheça o checklist essencial para começar cada dia com controle total.',
        category: 'rotina',
        readTime: 6,
        publishedAt: '2025-01-10',
        featured: true,
    },
    {
        id: '4',
        slug: 'o-que-e-ferramenta-monitoramento-gestores-trafego',
        title: 'O que é uma ferramenta de monitoramento para gestores de tráfego pago?',
        excerpt: 'Uma nova categoria de software está surgindo para resolver dores operacionais de quem gerencia campanhas. Entenda o que são e por que estão se tornando essenciais.',
        category: 'monitoramento',
        readTime: 8,
        publishedAt: '2025-12-12',
        featured: true,
    },
    {
        id: '5',
        slug: 'metricas-que-importam-vs-metricas-vaidade',
        title: 'Métricas que importam vs. métricas de vaidade: o que monitorar de verdade',
        excerpt: 'Nem todo número merece sua atenção. Aprenda a identificar os indicadores que realmente impactam resultados e como priorizá-los no dia a dia.',
        category: 'operacao',
        readTime: 6,
        publishedAt: '2025-01-06',
    },
    {
        id: '6',
        slug: 'automacao-gestor-trafego',
        title: 'Automação para gestor de tráfego: o que faz sentido automatizar (e o que não)',
        excerpt: 'Automação mal feita pode destruir resultados. Descubra o que deve ser automatizado e o que precisa do seu olhar humano.',
        category: 'operacao',
        readTime: 7,
        publishedAt: '2025-01-04',
    },
    {
        id: '7',
        slug: 'melhor-ferramenta-trafego-pago',
        title: 'Qual a melhor ferramenta para tráfego pago? Depende do seu objetivo',
        excerpt: 'Não existe ferramenta universal. Cada objetivo demanda um tipo diferente de solução. Entenda qual faz sentido para você.',
        category: 'ferramentas',
        readTime: 8,
        publishedAt: '2025-01-02',
    },
    {
        id: '8',
        slug: '5-ferramentas-gestor-trafego',
        title: '5 ferramentas que todo gestor de tráfego deveria conhecer (além das óbvias)',
        excerpt: 'Google Ads e Meta Ads são essenciais, mas não são suficientes. Conheça ferramentas que realmente fazem diferença na operação.',
        category: 'ferramentas',
        readTime: 7,
        publishedAt: '2024-12-30',
    },
    {
        id: '9',
        slug: 'dashboard-gestor-trafego',
        title: 'Dashboard para gestor de tráfego: como organizar informações de múltiplos clientes',
        excerpt: 'Um bom dashboard não é só bonito — é funcional. Aprenda a estruturar visualizações que realmente ajudam na tomada de decisão.',
        category: 'ferramentas',
        readTime: 6,
        publishedAt: '2024-12-28',
    },
    {
        id: '10',
        slug: 'salario-gestor-trafego',
        title: 'Qual é o salário médio de um gestor de tráfego no Brasil?',
        excerpt: 'Valores variam muito conforme experiência e modelo de trabalho. Veja a realidade do mercado e o que separa quem ganha mais.',
        category: 'carreira',
        readTime: 8,
        publishedAt: '2024-12-26',
    },
    {
        id: '11',
        slug: 'trafego-page-niveis',
        title: 'Tráfego pago: como funciona para iniciantes, intermediários, avançados e afiliados',
        excerpt: 'Cada nível tem desafios e necessidades diferentes. Entenda onde você está e o que precisa para evoluir.',
        category: 'carreira',
        readTime: 9,
        publishedAt: '2024-12-24',
        featured: true,
    },
    {
        id: '12',
        slug: 'quanto-cobrar-trafego-pago',
        title: 'Quanto cobrar por um contrato de tráfego pago?',
        excerpt: 'Precificação é uma das maiores dúvidas de gestores. Veja modelos, referências de mercado e como calcular seu valor.',
        category: 'carreira',
        readTime: 8,
        publishedAt: '2024-12-22',
    },
    {
        id: '13',
        slug: 'rei-do-trafego',
        title: 'Rei do Tráfego: o que é e para quem faz sentido',
        excerpt: 'Um dos treinamentos mais conhecidos do mercado. Entenda a proposta, para quem funciona e o que vem depois.',
        category: 'carreira',
        readTime: 6,
        publishedAt: '2024-12-30',
    },
    {
        id: '14',
        slug: 'kit-do-gestor-de-trafego',
        title: 'Kit do Gestor de Tráfego: organização resolve tudo?',
        excerpt: 'Ter ferramentas organizadas é importante, mas não garante que problemas não aconteçam. Entenda a diferença entre preparo e proteção.',
        category: 'ferramentas',
        readTime: 6,
        publishedAt: '2024-12-27',
    },
    {
        id: '15',
        slug: 'maleta-do-gestor-de-trafego',
        title: 'Maleta do Gestor de Tráfego: organização é só o começo',
        excerpt: 'A maleta representa preparo, mas monitoramento protege a operação. Descubra por que ambos são necessários.',
        category: 'ferramentas',
        readTime: 6,
        publishedAt: '2024-12-28',
    },
    {
        id: '16',
        slug: 'reportei-para-que-serve',
        title: 'Reportei: para que serve e quando faz sentido usar',
        excerpt: 'Relatórios mostram o passado. Monitoramento protege o presente. Entenda a diferença e quando usar cada ferramenta.',
        category: 'ferramentas',
        readTime: 6,
        publishedAt: '2024-12-22',
    },
    {
        id: '17',
        slug: 'pedro-sobral',
        title: 'Pedro Sobral: quem é e o que ele ensina sobre tráfego pago',
        excerpt: 'Um dos maiores nomes do tráfego no Brasil. Conheça sua trajetória e principais ensinamentos sobre gestão de campanhas.',
        category: 'carreira',
        readTime: 7,
        publishedAt: '2024-12-25',
    },
    {
        id: '18',
        slug: 'traqueamento-trafego',
        title: 'Traqueamento de tráfego: como garantir dados confiáveis',
        excerpt: 'Sem rastreamento correto, decisões são baseadas em achismos. Aprenda como configurar e monitorar o traqueamento das campanhas.',
        category: 'monitoramento',
        readTime: 7,
        publishedAt: '2025-01-15',
    },
    {
        id: '19',
        slug: 'mercado-negro-trafego',
        title: 'Mercado negro do tráfego pago: riscos e consequências',
        excerpt: 'Entenda por que práticas ilegais podem comprometer toda sua operação e como evitar armadilhas comuns do mercado.',
        category: 'operacao',
        readTime: 7,
        publishedAt: '2025-01-09',
    },
    {
        id: '20',
        slug: 'conta-bloqueada-saldo',
        title: 'Conta de anúncio bloqueada: quando o problema é falta de saldo (e como evitar)',
        excerpt: 'Saiba como identificar e evitar bloqueios por falta de saldo nas contas de anúncio. Veja dicas práticas para manter suas campanhas rodando.',
        category: 'problemas',
        readTime: 6,
        publishedAt: '2026-01-03',
    },
    {
        id: '21',
        slug: 'nicho-black',
        title: 'Nicho Black no tráfego pago: o que é, riscos e cuidados',
        excerpt: 'O termo “nicho black” é bastante buscado, mas também cercado de confusão. Entenda riscos e como se proteger.',
        category: 'operacao',
        readTime: 7,
        publishedAt: '2025-01-07',
    },
    {
        id: '22',
        slug: 'venda-de-bms',
        title: 'Venda de BMs: por que esse mercado existe e quais os riscos envolvidos',
        excerpt: 'O termo “venda de BMs” é bastante pesquisado por quem atua com tráfego pago. Mas o assunto exige cuidado e entendimento de contexto.',
        category: 'operacao',
        readTime: 7,
        publishedAt: '2025-01-05',
    },
];
var BlogIndex = function () {
    var _a = React.useState('all'), activeCategory = _a[0], setActiveCategory = _a[1];
    var _b = React.useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var filteredPosts = blogPosts.filter(function (post) {
        var matchesCategory = activeCategory === 'all' || post.category === activeCategory;
        var matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
    });
    var featuredPosts = blogPosts.filter(function (post) { return post.featured; });
    var formatDate = function (dateString) {
        return new Date(dateString).toLocaleDateString('pt-BR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };
    var getCategoryLabel = function (categoryId) {
        var _a;
        return ((_a = categories.find(function (c) { return c.id === categoryId; })) === null || _a === void 0 ? void 0 : _a.label) || categoryId;
    };
    return (React.createElement("div", { className: "min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-gray-950" },
        React.createElement("header", { className: "border-b border-gray-800 bg-gray-950/80 backdrop-blur-sm sticky top-0 z-50" },
            React.createElement("div", { className: "max-w-4xl mx-auto px-3 md:px-4 py-3 md:py-4 flex items-center justify-between" },
                React.createElement(Link, { to: "/", className: "flex items-center gap-1.5 md:gap-2" },
                    React.createElement("div", { className: "w-7 h-7 md:w-8 md:h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center" },
                        React.createElement("span", { className: "text-white font-bold text-xs md:text-sm" }, "VC")),
                    React.createElement("span", { className: "text-white font-semibold text-sm md:text-base" }, "VisionCockpit")),
                React.createElement("nav", { className: "flex items-center gap-2 md:gap-6" },
                    React.createElement(Link, { to: "/", className: "hidden md:block text-gray-400 hover:text-white transition-colors text-sm" }, "Produto"),
                    React.createElement(Link, { to: "/blog", className: "text-gray-400 hover:text-white transition-colors text-xs md:text-sm" }, "Blog"),
                    React.createElement(Link, { to: "/register", className: "bg-blue-600 hover:bg-blue-700 text-white px-2.5 md:px-4 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-colors" }, "Come\u00E7ar gr\u00E1tis")))),
        React.createElement("section", { className: "py-12 md:py-16 px-4" },
            React.createElement("div", { className: "max-w-6xl mx-auto text-center" },
                React.createElement(motion.div, { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.6 } },
                    React.createElement("span", { className: "inline-block px-3 py-1 bg-blue-500/10 border border-blue-500/20 rounded-full text-blue-400 text-sm mb-4 md:mb-6" }, "Blog VisionCockpit"),
                    React.createElement("h1", { className: "text-3xl md:text-4xl md:text-5xl font-bold text-white mb-3 md:mb-4" },
                        "Conte\u00FAdo para gestores de",
                        ' ',
                        React.createElement("span", { className: "text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500" }, "tr\u00E1fego pago")),
                    React.createElement("p", { className: "text-gray-400 text-base md:text-lg max-w-2xl mx-auto" }, "Artigos sobre monitoramento, alertas e opera\u00E7\u00E3o de campanhas. Aprenda a gerenciar m\u00FAltiplos clientes sem perder o controle.")))),
        React.createElement("section", { className: "px-4 pb-8" },
            React.createElement("div", { className: "max-w-6xl mx-auto" },
                React.createElement("div", { className: "flex flex-col gap-4" },
                    React.createElement("div", { className: "relative w-full" },
                        React.createElement(Search, { className: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" }),
                        React.createElement("input", { type: "text", placeholder: "Buscar artigos...", value: searchTerm, onChange: function (e) { return setSearchTerm(e.target.value); }, className: "w-full pl-10 pr-4 py-2.5 bg-gray-800/50 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-blue-500 transition-colors" })),
                    React.createElement("div", { className: "flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 scrollbar-hide" }, categories.map(function (category) {
                        var Icon = category.icon;
                        var isActive = activeCategory === category.id;
                        return (React.createElement("button", { key: category.id, onClick: function () { return setActiveCategory(category.id); }, className: "flex items-center gap-2 px-3 md:px-4 py-2 rounded-lg text-xs md:text-sm font-medium whitespace-nowrap transition-all ".concat(isActive
                                ? 'bg-blue-600 text-white'
                                : 'bg-gray-800/50 text-gray-400 hover:bg-gray-800 hover:text-white') },
                            React.createElement(Icon, { className: "w-3.5 h-3.5 md:w-4 md:h-4" }),
                            category.label));
                    }))))),
        React.createElement("section", { className: "px-4 pb-8" },
            React.createElement("div", { className: "max-w-6xl mx-auto" },
                React.createElement("div", { className: "grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" },
                    React.createElement("div", { className: "bg-gray-800/30 border border-gray-800 rounded-lg p-4 text-center" },
                        React.createElement("div", { className: "text-2xl md:text-3xl font-bold text-blue-400 mb-1" }, blogPosts.length),
                        React.createElement("div", { className: "text-xs md:text-sm text-gray-500" }, "Artigos publicados")),
                    React.createElement("div", { className: "bg-gray-800/30 border border-gray-800 rounded-lg p-4 text-center" },
                        React.createElement("div", { className: "text-2xl md:text-3xl font-bold text-purple-400 mb-1" }, categories.length - 1),
                        React.createElement("div", { className: "text-xs md:text-sm text-gray-500" }, "Categorias")),
                    React.createElement("div", { className: "bg-gray-800/30 border border-gray-800 rounded-lg p-4 text-center" },
                        React.createElement("div", { className: "text-2xl md:text-3xl font-bold text-green-400 mb-1" }, Math.round(blogPosts.reduce(function (acc, post) { return acc + post.readTime; }, 0) / blogPosts.length)),
                        React.createElement("div", { className: "text-xs md:text-sm text-gray-500" }, "Min de leitura m\u00E9dia")),
                    React.createElement("div", { className: "bg-gray-800/30 border border-gray-800 rounded-lg p-4 text-center" },
                        React.createElement("div", { className: "text-2xl md:text-3xl font-bold text-orange-400 mb-1" }, featuredPosts.length),
                        React.createElement("div", { className: "text-xs md:text-sm text-gray-500" }, "Posts em destaque"))))),
        activeCategory === 'all' && searchTerm === '' && (React.createElement("section", { className: "px-4 pb-12" },
            React.createElement("div", { className: "max-w-6xl mx-auto" },
                React.createElement("h2", { className: "text-lg md:text-xl font-semibold text-white mb-4 md:mb-6 flex items-center gap-2" },
                    React.createElement(TrendingUp, { className: "w-5 h-5 text-blue-400" }),
                    "Destaques"),
                React.createElement("div", { className: "grid md:grid-cols-2 gap-4 md:gap-6" }, featuredPosts.map(function (post, index) { return (React.createElement(motion.article, { key: post.id, initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.5, delay: index * 0.1 }, className: "group bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-xl p-5 md:p-6 hover:border-blue-500/50 transition-all" },
                    React.createElement(Link, { to: "/blog/".concat(post.slug) },
                        React.createElement("span", { className: "inline-block px-2 py-1 bg-blue-500/10 text-blue-400 text-xs font-medium rounded mb-3 md:mb-4" }, getCategoryLabel(post.category)),
                        React.createElement("h3", { className: "text-lg md:text-xl font-semibold text-white mb-2 md:mb-3 group-hover:text-blue-400 transition-colors line-clamp-2" }, post.title),
                        React.createElement("p", { className: "text-gray-400 text-sm mb-3 md:mb-4 line-clamp-2" }, post.excerpt),
                        React.createElement("div", { className: "flex items-center justify-between" },
                            React.createElement("div", { className: "flex items-center gap-3 md:gap-4 text-xs md:text-sm text-gray-500" },
                                React.createElement("span", { className: "flex items-center gap-1" },
                                    React.createElement(Clock, { className: "w-3.5 h-3.5 md:w-4 md:h-4" }),
                                    post.readTime,
                                    " min"),
                                React.createElement("span", { className: "hidden md:block" }, formatDate(post.publishedAt))),
                            React.createElement(ArrowRight, { className: "w-4 h-4 md:w-5 md:h-5 text-gray-600 group-hover:text-blue-400 group-hover:translate-x-1 transition-all" }))))); }))))),
        React.createElement("section", { className: "px-4 pb-16" },
            React.createElement("div", { className: "max-w-6xl mx-auto" },
                React.createElement("h2", { className: "text-lg md:text-xl font-semibold text-white mb-4 md:mb-6" },
                    activeCategory === 'all' ? 'Todos os artigos' : getCategoryLabel(activeCategory),
                    React.createElement("span", { className: "text-gray-500 font-normal ml-2" },
                        "(",
                        filteredPosts.length,
                        ")")),
                filteredPosts.length === 0 ? (React.createElement("div", { className: "text-center py-12" },
                    React.createElement(Search, { className: "w-12 h-12 text-gray-700 mx-auto mb-4" }),
                    React.createElement("p", { className: "text-gray-500 mb-2" }, "Nenhum artigo encontrado."),
                    React.createElement("button", { onClick: function () {
                            setSearchTerm('');
                            setActiveCategory('all');
                        }, className: "text-blue-400 hover:text-blue-300 text-sm" }, "Limpar filtros"))) : (React.createElement("div", { className: "grid gap-3 md:gap-4" }, filteredPosts.map(function (post, index) { return (React.createElement(motion.article, { key: post.id, initial: { opacity: 0, x: -20 }, animate: { opacity: 1, x: 0 }, transition: { duration: 0.4, delay: index * 0.05 }, className: "group bg-gray-800/30 border border-gray-800 rounded-lg p-4 md:p-5 hover:bg-gray-800/50 hover:border-gray-700 transition-all" },
                    React.createElement(Link, { to: "/blog/".concat(post.slug), className: "flex items-start justify-between gap-3 md:gap-4" },
                        React.createElement("div", { className: "flex-1 min-w-0" },
                            React.createElement("div", { className: "flex items-center gap-2 md:gap-3 mb-2" },
                                React.createElement("span", { className: "px-2 py-0.5 bg-gray-700/50 text-gray-400 text-xs rounded whitespace-nowrap" }, getCategoryLabel(post.category)),
                                React.createElement("span", { className: "text-gray-600 text-xs flex items-center gap-1 whitespace-nowrap" },
                                    React.createElement(Clock, { className: "w-3 h-3" }),
                                    post.readTime,
                                    " min")),
                            React.createElement("h3", { className: "text-base md:text-lg font-medium text-white group-hover:text-blue-400 transition-colors mb-1 line-clamp-2" }, post.title),
                            React.createElement("p", { className: "text-gray-500 text-xs md:text-sm line-clamp-1" }, post.excerpt)),
                        React.createElement("div", { className: "flex items-center gap-2 text-gray-600 flex-shrink-0" },
                            React.createElement("span", { className: "text-xs hidden lg:block" }, formatDate(post.publishedAt)),
                            React.createElement(ArrowRight, { className: "w-4 h-4 group-hover:text-blue-400 group-hover:translate-x-1 transition-all" }))))); }))))),
        React.createElement("section", { className: "px-4 pb-16" },
            React.createElement("div", { className: "max-w-4xl mx-auto" },
                React.createElement("div", { className: "bg-gradient-to-r from-blue-600/20 to-purple-600/20 border border-blue-500/30 rounded-xl md:rounded-2xl p-6 md:p-8 text-center" },
                    React.createElement("h2", { className: "text-xl md:text-2xl font-bold text-white mb-2 md:mb-3" }, "Cansado de apagar inc\u00EAndios?"),
                    React.createElement("p", { className: "text-gray-400 text-sm md:text-base mb-4 md:mb-6 max-w-xl mx-auto" }, "Ferramentas de monitoramento, como o VisionCockpit, ajudam gestores de tr\u00E1fego a identificar problemas antes que virem crises."),
                    React.createElement(Link, { to: "/register", className: "inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 md:px-6 py-2.5 md:py-3 rounded-lg text-sm md:text-base font-medium transition-colors" },
                        "Testar gr\u00E1tis por 14 dias",
                        React.createElement(ArrowRight, { className: "w-4 h-4" })))))));
};
export default BlogIndex;
